export const headers = {
    initialHeaders: [
        {title: 'Location Name', field: 'location', child: null},
        {title: 'No. Nights', field: 'days', child: null},
        {title: 'Check-in', field: 'arrival', child: null},
        {title: 'Check-out', field: 'departure', child: null},
        {title: 'Group', field: 'isGroup', child: null},
        {title: 'Status', field: 'status', child: null},
    ]
}